export interface MentionableUserOption {
    label: string;
    value: string;
}

export class MentionableUser {
    public type: string = 'user';
    public id: string = '';
    public name: string = '';
    public mentionableLabel: string = "";
    public mentionableValue: string = "";

    public GetMentionableUserOption(): MentionableUserOption {
        return {
            label: this.mentionableLabel,
            value: this.mentionableValue
        };
    }

    public constructor(name: string) {
        this.name = name;
        this.mentionableLabel = name;
        this.mentionableValue = name.toLowerCase().replace(/\s/g, '');
    }
}